<template>
  <div class="success_home">
    <div id="content" class="about_background content">
      <img class="success_top" :src="item"/>
      <div>
        <img class="success_center" src="static/failed_center.png" />
        <div
            class="hint-text"
            v-show="true" 
          >{{errorText}}
        </div>
        <br/>
      </div>
      <div class="bottom" style="margin-top: 16%">
      </div>
    </div>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
import urlParam from '../../../common/url.js';
import 'swiper/css/swiper.css'
export default {
  name: "showError",
  components: {
    wTitleBar
  },
  data() {
    return {
      title: '',
      srcFlag: true,
      responseData: null,
      errorText: "",
      item: "/static/success_top.png",
    };
  },
  computed: {
    i18n() {
      this.title = this.$t('success.title');
      return this.$t('success');
    }
  },
  mounted() {
    // 计算toolbar高度
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
    // 获取数据
    let errorText = urlParam.getUrlKey('errorText');
    this.errorText = errorText;
  },
  methods: {
    gotoHome() {
      this.$router.back();
    },
    getMessage(e) {
      this.$alert(e, "标题名称", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },
    carousel(){
      this.$refs.carousel.setActiveItem(index);
    }
  },
};
</script>

<style lang="less" scoped>
.about_background {
  background-color: #f6f6f6;
}
.content {
  // margin-top: -44px;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  // margin-top: 44px;
  width: 100vw;
}
.success_center {
  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -38%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 700;
  color: rgba(43, 27, 2, 1);
  line-height: 56px;
}
.text-pass_bottom{
  margin-top: -2%;
  text-align: center;
  font-size: 17px;
  // font-family: PingFang;
  // font-weight: 700;
  // color: rgba(43, 27, 2, 1);
  // line-height: 56px;
}
.hint-text {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(208, 2, 27, 1);
  line-height: 15px;
  margin-top: -34%;
  // margin-bottom: -9%;
  // margin-bottom: 9%;
}
.picture-position {
  margin-top: 16%;
  // margin-top: 22%;
  margin-left: 10px;
  margin-right: 10px;
  height: 250px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.bottom {
  margin-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #C3C3C3;
  font-family:PingFang;
}
.hide{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/wechat/showError.vue